import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  homePage: null,
  solutionPage: null,
  challengePage: null,
  sectorPage: null,
  rolePage: null,
  contractorPage: null,
  productFeaturePage: null,
  constructionPage: null,
  projectManagementMainPage: null,
  fieldManagementPage: null,
  resourcePlanningPage: null,
  timeManagementPage: null,

  // safety checklist page
  safetyChecklistPage: null,

  // daily checklist page
  dailyChecklistPage: null,

  // communication management page
  communicationManagementPage: null,

  // schedule performance page
  schedulePerformancePage: null,

  // cost performance page
  costPerformancePage: null,

  // close out page
  closeOutPage: null,

  // document control page
  documentControlPage: null,

  // financial management page
  financialManagementPage: null,

  // report & analytics page
  reportAnalyticsPage: null,

  // tech product & integration page
  technologyIntegrationPage: null,

  // user management page
  userManagementPage: null,

  // office management page
  officeManagementPage: null,

  // pre construction page
  preConstructionPage: null,

  // post construction page
  postConstructionPage: null,

  // software development page
  softwareDevelopmentPage: null,

};

const websiteSlice = createSlice({
  name: 'website',
  initialState,
  reducers: {
    setHomePage: (state, action) => {
      state.homePage = action.payload;
    },
    setSolutionPage: (state, action) => {
      state.solutionPage = action.payload;
    },
    setchallengePage: (state, action) => {
      state.challengePage = action.payload;
    },
    setSectorPage: (state, action) => {
      state.sectorPage = action.payload;
    },
    setRolePage: (state, action) => {
      state.rolePage = action.payload;
    },
    setContractorPage: (state, action) => {
      state.contractorPage = action.payload;
    },
    setProductFeaturePage: (state, action) => {
      state.productFeaturePage = action.payload;
    },
    setConstructionPage: (state, action) => {
      state.constructionPage = action.payload;
    },
    setProjectManagementMainPage: (state, action) => {
      state.projectManagementMainPage = action.payload;
    },
    setFieldManagementPage: (state, action) => {
      state.fieldManagementPage = action.payload;
    },
    setResourcePlanningPage: (state, action) => {
      state.resourcePlanningPage = action.payload;
    },
    setTimeManagementPage: (state, action) => {
      state.timeManagementPage = action.payload;
    },

    // safety checklist page
    setSafetyChecklistPage: (state, action) => {
      state.safetyChecklistPage = action.payload;
    },

    // checklist page
    setDailyChecklistPage: (state, action) => {
      state.dailyChecklistPage = action.payload;
    },

    //communication management page
    setCommunicationManagementPage: (state, action) => {
      state.communicationManagementPage = action.payload;
    },

    //schedule performace page
    setSchedulePerformancePage: (state, action) => {
      state.schedulePerformancePage = action.payload;
    },

    //cost performace page
    setCostPerformancePage: (state, action) => {
      state.costPerformancePage = action.payload;
    },

    //close out page
    setCloseOutPage: (state, action) => {
      state.closeOutPage = action.payload;
    },

    //document control page
    setDocumentControlPage: (state, action) => {
      state.documentControlPage = action.payload;
    },

    //financial management page
    setFinancialManagementPage: (state, action) => {
      state.financialManagementPage = action.payload;
    },

    // report & analytics page
    setReportAnalyticsPage: (state, action) => {
      state.reportAnalyticsPage = action.payload;
    },

    //tech product & integration page
    setTechnologyIntegrationPage: (state, action) => {
      state.technologyIntegrationPage = action.payload;
    },

    //user management page
    setUserManagementPage: (state, action) => {
      state.userManagementPage = action.payload;
    },

    //office management page
    setOfficeManagementPage: (state, action) => {
      state.officeManagementPage = action.payload;
    },

    //pre construction page
    setPreConstructionPage: (state, action) => {
      state.preConstructionPage = action.payload;
    },

    //post construction page
    setPostConstructionPage: (state, action) => {
      state.postConstructionPage = action.payload;
    },

    //software development page
    setSoftwareDevelopmentPage: (state, action) => {
      state.softwareDevelopmentPage = action.payload;
    },

  },
});

export const { setHomePage, setSolutionPage, setchallengePage, setSectorPage, setRolePage, setContractorPage, setProductFeaturePage, setConstructionPage, setProjectManagementMainPage, setFieldManagementPage, setResourcePlanningPage, setTimeManagementPage, setSafetyChecklistPage, setDailyChecklistPage,
  setCommunicationManagementPage, setSchedulePerformancePage, setCostPerformancePage, setCloseOutPage, setDocumentControlPage, setFinancialManagementPage
  , setReportAnalyticsPage, setTechnologyIntegrationPage, setUserManagementPage, setOfficeManagementPage, setPreConstructionPage, setPostConstructionPage
  , setSoftwareDevelopmentPage } = websiteSlice.actions;
export default websiteSlice.reducer;
